import PropTypes from 'prop-types';

/**
 * Contentful Image properties
 */
export const imagePropType = PropTypes.shape({
  title: PropTypes.string,
  file: {
    fileName: PropTypes.string,
    url: PropTypes.string,
  },
});

/**
 * Contentful Logo properties
 */
export const logoPropType = PropTypes.shape({
  color: PropTypes.string,
  coverImage: imagePropType,
  image: imagePropType,
  link: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  useImageInExploreMenu: PropTypes.bool,
  useSpyscapeFont: PropTypes.bool,
});

/**
 * Contentful 'Navigation Item' content type properties
 */
export const navigationItemPropType = PropTypes.shape({
  title: PropTypes.string,
  link: PropTypes.string,
  icon: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
  activeTextColor: PropTypes.string,
  hoverTextColor: PropTypes.string,
  hoverBackgroundColor: PropTypes.string,
  subItems: PropTypes.array,
  additionalItems: PropTypes.array,
  showIfUserLoggedIn: PropTypes.bool,
  arrowAlternate: PropTypes.bool,
});

/**
 * Contentful 'Navigation Logo Item' content type properties
 */
export const navigationLogoItemPropType = PropTypes.shape({
  title: PropTypes.string,
  prefix: PropTypes.string,
  text: PropTypes.string,
  color: PropTypes.string,
  useSpyscapeFont: PropTypes.bool,
  image: PropTypes.object,
  useImageInExploreMenu: PropTypes.bool,
  coverImage: PropTypes.object,
  link: PropTypes.string,
  subTitle: PropTypes.string,
});

/**
 * Contentful 'Explore Menu' content type properties
 */
export const exploreMenuPropType = PropTypes.shape({
  items: PropTypes.array.isRequired,
  subMenuButtonLabel: PropTypes.string,
  openSubMenuButtonLabel: PropTypes.string,
  subItems: PropTypes.array,
});

/**
 * Contentful 'Site' content type properties
 */
export const sitePropType = PropTypes.shape({
  logo: navigationLogoItemPropType,
  primaryColor: PropTypes.string,
  topRightItem: navigationItemPropType,
  topRightItems: PropTypes.arrayOf(navigationItemPropType),
  exploreMenu: PropTypes.arrayOf(navigationLogoItemPropType),
  secondaryMenu: PropTypes.arrayOf(navigationItemPropType),
});

/**
 * Contentful mixed response data properties
 */
export const contentfulDataPropType = PropTypes.shape({
  exploreMenu: exploreMenuPropType,
  logo: logoPropType,
  primaryColor: PropTypes.string,
  secondaryMenu: PropTypes.arrayOf(navigationItemPropType),
  topRightItem: navigationItemPropType,
  topRightItems: PropTypes.arrayOf(navigationItemPropType),
});

/**
 * SPYSCAPE Venue properties
 */

export const venuePropType = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
);
